<template>
  <div
    v-tooltip="
      showTooltip && {
        content: passName,
        placement: 'bottom-center',
      }
    "
    class="passes"
  >
    <component
      :is="iconShown"
      :height="size"
      :width="size"
      :fill="fill"
      class="passes__icon"
    />
  </div>
</template>

<script>
import Cloud from '@/assets/icons/passes/cloud_white.svg'
import CyberSecurity from '@/assets/icons/passes/cybersecurity_white.svg'
import DataScience from '@/assets/icons/passes/datascience_white.svg'
import Development from '@/assets/icons/passes/development_white.svg'
import ITEssentials from '@/assets/icons/passes/itessentials_white.svg'
import Networking from '@/assets/icons/passes/networking_white.svg'
import CloudBlack from '@/assets/icons/passes/cloud_black.svg'
import CyberSecurityBlack from '@/assets/icons/passes/cybersecurity_black.svg'
import DataScienceBlack from '@/assets/icons/passes/datascience_black.svg'
import DevelopmentBlack from '@/assets/icons/passes/development_black.svg'
import ITEssentialsBlack from '@/assets/icons/passes/itessentials_black.svg'
import NetworkingBlack from '@/assets/icons/passes/networking_black.svg'
import AnnualWhite from '@/assets/icons/passes/annual_white.svg'
import EnterpriseWhite from '@/assets/icons/passes/enterprise_white.svg'
import MonthlyWhite from '@/assets/icons/passes/monthly_white.svg'
import PremiumWhite from '@/assets/icons/passes/premium_white.svg'
import ProfessionalWhite from '@/assets/icons/passes/professional_white.svg'

export default {
  name: 'Passes',
  components: {
    Cloud: { ...Cloud, name: 'Cloud' },
    CyberSecurity: { ...CyberSecurity, name: 'CyberSecurity' },
    DataScience: { ...DataScience, name: 'DataScience' },
    Development: { ...Development, name: 'Development' },
    ITEssentials: { ...ITEssentials, name: 'ITEssentials' },
    Networking: { ...Networking, name: 'Networking' },
    CloudBlack: { ...CloudBlack, name: 'CloudBlacks' },
    CyberSecurityBlack: {
      ...CyberSecurityBlack,
      name: 'CyberSecurityBlacks',
    },
    DataScienceBlack: { ...DataScienceBlack, name: 'DataScienceBlacks' },
    DevelopmentBlack: { ...DevelopmentBlack, name: 'DevelopmentBlacks' },
    ITEssentialsBlack: {
      ...ITEssentialsBlack,
      name: 'ITEssentialsBlacks',
    },
    NetworkingBlack: { ...NetworkingBlack, name: 'NetworkingBlacks' },
    AnnualWhite: { ...AnnualWhite, name: 'AnnualWhite' },
    EnterpriseWhite: { ...EnterpriseWhite, name: 'EnterpriseWhite' },
    MonthlyWhite: { ...MonthlyWhite, name: 'MonthlyWhite' },
    PremiumWhite: { ...PremiumWhite, name: 'PremiumWhite' },
    ProfessionalWhite: {
      ...ProfessionalWhite,
      name: 'ProfessionalWhite',
    },
  },
  props: {
    passName: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      required: false,
      default() {
        return 45
      },
    },
    showTooltip: {
      type: Boolean,
      required: false,
      default() {
        return true
      },
    },
    fill: {
      type: String,
      required: false,
      default() {
        return 'white'
      },
    },
  },
  computed: {
    iconShown() {
      const whiteIcons = {
        Networking,
        'Cyber Security': CyberSecurity,
        'IT Essentials': ITEssentials,
        Development,
        'Data Science': DataScience,
        Cloud,
        'Individual Annual': AnnualWhite,
        'Individual Monthly': MonthlyWhite,
        Premium: PremiumWhite,
        Enterprise: EnterpriseWhite,
        Professional: ProfessionalWhite,
      }
      const blackIcons = {
        Networking: NetworkingBlack,
        'Cyber Security': CyberSecurityBlack,
        'IT Essentials': ITEssentialsBlack,
        Development: DevelopmentBlack,
        'Data Science': DataScienceBlack,
        Cloud: CloudBlack,
        'Individual Annual': AnnualWhite,
        'Individual Monthly': MonthlyWhite,
        Premium: PremiumWhite,
        Enterprise: EnterpriseWhite,
        Professional: ProfessionalWhite,
      }
      if (this.fill === 'white') {
        return whiteIcons[this.passName] || Networking
      }
      return blackIcons[this.passName] || NetworkingBlack
    },
  },
}
</script>
